import Image from 'next/image';

const Header = () => {
  return (
    <header className="px-[5%] lg:px-[16%] mt-10 lg:mt-16">
      <div className="flex justify-center gap-2">
        <div className="flex-none w-[33.33%] md:min-h-[150px] ">
          <div className="flex flex-col  items-center h-full">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1689860766/Remaining%20images/Partners/Free_content_to_promote_1_hvkycq.svg"
              width={50}
              height={50}
              alt="See Sight Tours"
            />
            <p className="text-center text-sm sm:text-base lg:text-[20px] font-semibold flex-none md:h-[25%] pt-3">
              Free content to promote
            </p>
            <p className="text-[10px] sm:text-xs lg:text-lg font-normal text-center hidden md:block px-[10%]">
              Boost sales using See Sight Tours&apos; high-performing content
              with your audience.
            </p>
          </div>
        </div>
        <div className="flex-none w-[33.33%] md:min-h-[150px] ">
          <div className="flex flex-col  items-center h-full">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690183781/Remaining%20images/Partners/Easy_payout_1_i2eta1.svg"
              width={50}
              height={50}
              alt="See Sight Tours"
            />
            <p className="text-center text-sm sm:text-base lg:text-[20px] font-semibold flex-none md:h-[25% pt-3">
              Easy Payout
            </p>
            <p className="text-[10px] sm:text-xs lg:text-lg font-normal text-center hidden md:block px-[12%]">
              Enjoy worry-free credit with monthly commissions added to your
              account.
            </p>
          </div>
        </div>
        <div className="flex-none w-[33.33%] md:min-h-[150px] ">
          <div className="flex flex-col  items-center h-full">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1689854415/Remaining%20images/Partners/Tracking_you_can_rely_on_j46r4a.svg"
              width={50}
              height={50}
              alt="See Sight Tours"
            />
            <p className="text-center text-sm sm:text-base lg:text-[20px] font-semibold flex-none md:h-[25%] pt-3">
              Tracking you can rely on
            </p>
            <p className="text-[10px] sm:text-xs lg:text-lg font-normal text-center hidden md:block px-[14%] ">
              Track sales and earn credit for every referral with our leading
              platforms.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
